import { PageId } from 'constants/pages'

export const enum PageIdWoofzPup {
  DOG_AGE_PUP = PageId.DOG_AGE_PUP,
  DOG_OWNER_PUP = PageId.DOG_OWNER_PUP,
  TRAINING_COMMANDS_PUP = PageId.TRAINING_COMMANDS_PUP,
  URGE_PAGE_PUP = PageId.URGE_PAGE_PUP,
  DOG_BREED_PUP = PageId.DOG_BREED_PUP,
  FACING_CHALLENGES_PUP = PageId.FACING_CHALLENGES_PUP,
  FACING_CHALLENGES_2_PUP = PageId.FACING_CHALLENGES_2_PUP,
  BEHAVIOR_FREQUENCY_PUP = PageId.BEHAVIOR_FREQUENCY_PUP,
  URGE_PROGRAM_PUP = PageId.URGE_PROGRAM_PUP,
  BEHAVIOR_FEELINGS_PUP = PageId.BEHAVIOR_FEELINGS_PUP,
  FIX_BEHAVIOR_PUP = PageId.FIX_BEHAVIOR_PUP,
  URGE_PAGE_4_PUP = PageId.URGE_PAGE_4_PUP,
  COMMANDS_PUP = PageId.COMMANDS_PUP,
  PARENT_GOAL_PUP = PageId.PARENT_GOAL_PUP,
  TRAINING_PLACE_PUP = PageId.TRAINING_PLACE_PUP,
  TRAINING_FREQUENCY_PUP = PageId.TRAINING_FREQUENCY_PUP,
  URGE_PAGE_5_PUP = PageId.URGE_PAGE_5_PUP,
  PREPARE_FLOW_PUP = PageId.PREPARE_FLOW_PUP,
  EMAIL_PUP = PageId.EMAIL_PUP,
  NEWSLETTER_URGE_PUP = PageId.NEWSLETTER_URGE_PUP,
  LAST_CHANCE_OFFER_PUP = PageId.LAST_CHANCE_OFFER_PUP,
  SUBSCRIPTIONS_PUP = PageId.SUBSCRIPTIONS_PUP,
  CHAT_UPSELL_PUP = PageId.CHAT_UPSELL_PUP,
  UPSELL_PUP = PageId.UPSELL_PUP,
  UPSELL_FEEDING_GUIDE_PUP = PageId.UPSELL_FEEDING_GUIDE_PUP,
  UPSELL_EMOTIONAL_SUPPORT_PUP = PageId.UPSELL_EMOTIONAL_SUPPORT_PUP,
  DOWNLOAD_PUP = PageId.DOWNLOAD_PUP,
  ACCOUNT_NOVE8 = PageId.ACCOUNT_NOVE8,
}
